var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDscLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 100,
    viewBox: "0 0 627.265 213.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .a,.b{fill:none;stroke:#e22910;stroke-miterlimit:10;}.b{stroke-width:2px;}.c{fill:#5f5f5f;}.d{fill:#f23819;}.e{fill:#00a651;}.f{fill:#ffaf00;}.f,.g{opacity:0.85;}.g{fill:#e22910;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-653.548 -270.013)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M872.262,384.23",
    transform: "translate(-14.056 -7.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M895.912,384.23",
    transform: "translate(-15.576 -7.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M940.279,435.668h0a11.779,11.779,0,0,1,11.795-.185,9.525,9.525,0,0,0,4.894,1.18c4.45,0,5.562-1.756,5.562-3.338,0-2.517-2.342-3.514-8.49-5.211-6.09-1.7-12.062-4.626-12.062-12.472,0-7.905,6.676-12.472,13.76-12.472a15.9,15.9,0,0,1,14.99,9.252l-.476.279a11.975,11.975,0,0,1-11.134.267,7.946,7.946,0,0,0-3.38-.663c-2.927,0-4.391,1.464-4.391,3.1,0,1.873.995,3.162,7.377,5.094,6.208,1.873,13.175,4.041,13.175,12.706,0,7.905-6.323,12.59-15.223,12.59C948.067,445.8,942.562,441.7,940.279,435.668Z",
    transform: "translate(-18.428 -8.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M978.079,431.143a15.486,15.486,0,0,1,28.75-7.964l-1.109.644a12.475,12.475,0,0,1-10.067.849,7.255,7.255,0,0,0-2.175-.321,6.795,6.795,0,0,0,0,13.585,7.362,7.362,0,0,0,2.186-.321,12.666,12.666,0,0,1,10.127.839l1.038.594A14.947,14.947,0,0,1,993.6,446.6,15.168,15.168,0,0,1,978.079,431.143Z",
    transform: "translate(-20.857 -9.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1040.606,427.057v9.194a8.782,8.782,0,0,1-8.783,8.783h0V428.346c0-3.631-2.283-5.329-5.093-5.329-3.22,0-5.447,1.874-5.447,6.032v15.985h0a8.782,8.782,0,0,1-8.783-8.783V404.045h0a8.782,8.782,0,0,1,8.783,8.783v5.681c1.582-2.166,4.51-3.573,8.375-3.573C1035.569,414.936,1040.606,419.152,1040.606,427.057Z",
    transform: "translate(-23.069 -8.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1047.359,431.143a15.517,15.517,0,1,1,15.516,15.459A15.346,15.346,0,0,1,1047.359,431.143Zm22.251,0a6.736,6.736,0,1,0-6.734,6.909A6.567,6.567,0,0,0,1069.61,431.143Z",
    transform: "translate(-25.31 -9.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1084.22,431.143a15.517,15.517,0,1,1,15.516,15.459A15.346,15.346,0,0,1,1084.22,431.143Zm22.251,0a6.736,6.736,0,1,0-6.734,6.909A6.568,6.568,0,0,0,1106.471,431.143Z",
    transform: "translate(-27.679 -9.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1122.644,402.168h0a8.782,8.782,0,0,1,8.783,8.783v33.962h-8.783Z",
    transform: "translate(-30.148 -8.493)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1152.873,424.483c0-12.062,8.958-21.314,21.313-21.314a20.443,20.443,0,0,1,17.567,9.486l-1.7.987a10.5,10.5,0,0,1-10.244-.006,11.94,11.94,0,0,0-5.622-1.332c-7.26,0-11.945,4.86-11.945,12.179s4.684,12.18,11.945,12.18a12.053,12.053,0,0,0,5.644-1.332,11.431,11.431,0,0,1,11.016.455l.907.526a20.3,20.3,0,0,1-17.567,9.486C1161.831,445.8,1152.873,436.546,1152.873,424.483Z",
    transform: "translate(-32.091 -8.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1199.371,402.168h0a8.782,8.782,0,0,1,8.783,8.783v33.962h-8.783Z",
    transform: "translate(-35.079 -8.493)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1214.016,431.143a15.517,15.517,0,1,1,15.516,15.459A15.346,15.346,0,0,1,1214.016,431.143Zm22.251,0a6.736,6.736,0,1,0-6.734,6.909A6.568,6.568,0,0,0,1236.267,431.143Z",
    transform: "translate(-36.02 -9.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1280.11,425.345v20.493h-8.785v-2.752c-1.58,2.167-4.508,3.573-8.373,3.573-5.914,0-10.95-4.216-10.95-12.121v-9.193a8.784,8.784,0,0,1,8.784-8.785h0v16.689c0,3.631,2.283,5.328,5.094,5.328,3.22,0,5.445-1.873,5.445-6.031V416.56h0A8.784,8.784,0,0,1,1280.11,425.345Z",
    transform: "translate(-38.461 -9.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1318.8,412.829v32.205h-8.785v-2.752c-1.932,2.225-4.8,3.573-8.725,3.573-7.67,0-13.994-6.734-13.994-15.459s6.324-15.459,13.994-15.459c3.924,0,6.792,1.347,8.725,3.573V404.045h0A8.784,8.784,0,0,1,1318.8,412.829Zm-8.785,17.566c0-4.391-2.927-7.144-6.968-7.144s-6.968,2.753-6.968,7.144,2.928,7.143,6.968,7.143S1310.018,434.787,1310.018,430.4Z",
    transform: "translate(-40.73 -8.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1028.357,358.306h-6.045V376.6h0a12.726,12.726,0,0,1-12.726-12.725v-42.95h22.27a19.042,19.042,0,0,1,19.088,19.089,18.347,18.347,0,0,1-10.259,16.145l11.85,20.441h-5.854a13.514,13.514,0,0,1-11.721-6.788Zm-6.045-11.135h9.545c3.5,0,6.363-3.1,6.363-7.157s-2.863-7.158-6.363-7.158h-9.545Z",
    transform: "translate(-22.882 -3.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1083.081,333.649V376.6h-12.725V320.924h0A12.725,12.725,0,0,1,1083.081,333.649Z",
    transform: "translate(-26.787 -3.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1097.553,320.924h.033a18.681,18.681,0,0,1,17.888,13.3l8.325,27.663,8.317-27.632a18.725,18.725,0,0,1,17.931-13.329h0L1131.912,376.6h-16.225Z",
    transform: "translate(-28.535 -3.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1179.973,333.649V376.6h-12.725V320.924h0A12.725,12.725,0,0,1,1179.973,333.649Z",
    transform: "translate(-33.015 -3.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1243.291,333.65V376.6h-1.74a15.122,15.122,0,0,1-12.326-6.362l-16.953-23.862v17.5a12.726,12.726,0,0,1-12.725,12.725h0V320.924h3.389a11.921,11.921,0,0,1,9.719,5.017l17.91,25.206V320.924h0A12.726,12.726,0,0,1,1243.291,333.65Z",
    transform: "translate(-35.09 -3.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1319.945,350.275c0,17.021-11.852,27.361-27.44,27.361-17.5,0-30.065-12.885-30.065-28.872a28.874,28.874,0,0,1,29.19-29.03,30.489,30.489,0,0,1,12.812,2.762,9.109,9.109,0,0,1,.709,16.168h0c-2.307-3.659-7.317-6.522-13.6-6.522-9.385,0-16.384,6.92-16.384,16.7,0,9.466,6.68,16.385,17.5,16.385,7.4,0,12.248-3.261,14.237-8.589h-14.873a11.136,11.136,0,0,1,11.135-11.136h16.782Z",
    transform: "translate(-39.132 -3.195)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M990.778,349.2c0,16.136-11.98,28.523-27.709,28.523H940.25V333.585a12.91,12.91,0,0,1,12.91-12.909h9.908C978.8,320.676,990.778,333.062,990.778,349.2Zm-12.55,0c0-9.78-6.194-15.974-15.159-15.974h-9.779v31.946h9.779C972.034,365.171,978.228,358.978,978.228,349.2Z",
    transform: "translate(-18.426 -3.256)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.548 270.013)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M886.87,420.187l-73.936,58.366c-14.625,11.544-43.054,12.733-63.5,2.655L673.4,443.729c-20.447-10.078-25.166-27.607-10.542-39.151L736.8,346.211c14.624-11.545,43.054-12.733,63.5-2.655l76.032,37.478C896.775,391.114,901.494,408.643,886.87,420.187Z",
    transform: "translate(-653.6 -274.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M884.261,411.359l-83.379,43.832c-16.491,8.67-44.877,4.211-63.4-9.958l-68.886-52.69c-18.524-14.169-20.172-32.683-3.68-41.353l83.378-43.833c16.492-8.67,44.878-4.212,63.4,9.958l68.885,52.69C899.1,384.175,900.752,402.689,884.261,411.359Z",
    transform: "translate(-653.548 -272.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M879.479,406.926l-92.048,26.694c-18.207,5.279-43.41-5.413-56.295-23.882l-52.411-74.3c-12.884-18.469-8.569-37.721,9.636-43l96.546-21.071c18.207-5.279,43.41,5.412,56.295,23.882l47.913,68.681C902,382.393,897.685,401.645,879.479,406.926Z",
    transform: "translate(-654.689 -270.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M786.254,467.711",
    transform: "translate(-662.077 -282.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M786.254,467.711",
    transform: "translate(-662.077 -282.719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDscLogo);
export default __webpack_public_path__ + "static/media/dsc_logo.7b81ba8e0bd5ab195710f3ead3f3ef65.svg";
export { ForwardRef as ReactComponent };